function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @param actionCreator
 * @param options = {dataProp , shouldDestroyData, defaultData, shouldSpread, shouldSetData, dataGetter})
 * @returns {Function}
 */
export default function makeAsyncReducer(actionCreator, options) {
  var defaults = {
    dataProp: 'data',
    shouldDestroyData: true,
    shouldDestroyDataOnError: true,
    shouldSetError: true,
    defaultData: undefined,
    shouldSpread: false,
    shouldSetData: true,
    dataGetter: undefined,
    saveAsyncFnArgs: false
  };
  options = Object.assign(defaults, options);
  var defaultState = options.shouldSpread ? _objectSpread({
    error: undefined,
    loading: false,
    loaded: false
  }, options.defaultData || {}) : _defineProperty({
    error: undefined,
    loading: false,
    loaded: false
  }, options.dataProp, options.defaultData);
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

    var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref2.type,
        payload = _ref2.payload,
        meta = _ref2.meta;

    switch (type) {
      case actionCreator.TYPE:
        return options.shouldSpread ? _objectSpread(_objectSpread({
          loading: true,
          loaded: state && state.loaded || false
        }, options.shouldDestroyDataOnError ? {} : {
          error: state.error
        }), options.defaultData || {}) : _objectSpread(_objectSpread({
          loading: true,
          loaded: state && state.loaded || false
        }, options.shouldDestroyDataOnError ? {} : {
          error: state.error
        }), {}, _defineProperty({}, options.dataProp, options.shouldDestroyData ? options.defaultData : state[options.dataProp]));

      case actionCreator.success.TYPE:
        {
          if (!options.shouldSetData) {
            return {
              loading: false,
              loaded: true
            };
          }

          var progress = state && state.progress === undefined ? {} : {
            progress: 0
          };
          var data = typeof options.dataGetter === 'function' ? options.dataGetter(state, {
            type: type,
            payload: payload,
            meta: meta
          }) : payload;
          return options.shouldSpread ? _objectSpread(_objectSpread(_objectSpread({
            loading: false,
            loaded: true
          }, progress), data), options.saveAsyncFnArgs ? {
            asyncFnArgs: meta === null || meta === void 0 ? void 0 : meta._toolbeltAsyncFnArgs
          } : {}) : _objectSpread(_objectSpread({
            loading: false,
            loaded: true
          }, progress), {}, _defineProperty({}, options.dataProp, data), options.saveAsyncFnArgs ? {
            asyncFnArgs: meta === null || meta === void 0 ? void 0 : meta._toolbeltAsyncFnArgs
          } : {});
        }

      case actionCreator.progress.TYPE:
        return _objectSpread(_objectSpread({}, state), {}, {
          progress: payload
        });

      case actionCreator.failure.TYPE:
        return _objectSpread(_objectSpread({}, options.shouldDestroyDataOnError ? {} : state), {}, {
          loading: false,
          error: options.shouldSetError ? payload : undefined
        }, options.saveAsyncFnArgs ? {
          asyncFnArgs: meta === null || meta === void 0 ? void 0 : meta._toolbeltAsyncFnArgs
        } : {});

      default:
        return state;
    }
  };
}

makeAsyncReducer.withDefaults = function (defaults) {
  return function (actionCreator, options) {
    options = Object.assign({}, defaults, options);
    return makeAsyncReducer(actionCreator, options);
  };
};